module.exports = __webpack_public_path__ + "static/media/pdp_boat_mid-banner-mob.29ff6e46.png";